import { toast } from "react-toastify";
import {
  useAddSnapshotCollectionFavoriteMutation,
  useDeleteSnapshotCollectionFavoriteMutation,
  useGetSnapshotCollectionFavoritesQuery,
} from "@/modules/snapshots/snapshotCollection.api";

export const useFavoriteCollection = (collectionId: string, { skip = false }: { skip?: boolean } = {}) => {
  const { data: favorites = [] } = useGetSnapshotCollectionFavoritesQuery(undefined, { skip });
  const [addFavorite] = useAddSnapshotCollectionFavoriteMutation();
  const [removeFavorite] = useDeleteSnapshotCollectionFavoriteMutation();

  const isFavorited = favorites.some(fav => fav.snapshot_collection_id === collectionId);

  const handleToggleFavorite = async () => {
    try {
      if (isFavorited) {
        await removeFavorite({ snapshot_collection_id: collectionId }).unwrap();
        toast.success("Removed from favorites");
      } else {
        await addFavorite({ snapshot_collection_id: collectionId }).unwrap();
        toast.success("Added to favorites");
      }
    } catch (_error) {
      toast.error("Failed to update favorite status");
    }
  };

  return { isFavorited, handleToggleFavorite };
};
